import { DEFAULT_LANGUAGE, LANG_MODE_DEFAULT, } from '@/constants';
import type { LangOption, LangTypeMode, Language, LanguageState, Side } from '@/services/translation/translate-service.interface';
import { ref } from 'vue';
import { store } from '../vuex/store';

export function useStore() {

    const lang = ref<LanguageState>(store.state.root.lang);

    const langType = ref<LangTypeMode>(store.state.root.langType);

    const userPreferredLangOptions = ref<LangOption>(store.state.root.userPreferredLangOption);

    store.subscribe((mutation, state) => {
        const oldValue = lang.value;
        const newValue = state.root.lang;

        if (oldValue.left !== newValue.left || oldValue.right !== newValue.right) {
            lang.value = newValue;
        }
        langType.value = { ...state.root.langType };
        userPreferredLangOptions.value = state.root.userPreferredLangOption;
    });

    function switchTranslateLanguage(options: { side?: Side; lang?: Language; langType?: LangTypeMode}) {
        store.dispatch('root/setLang', {
            side: options.side || 'left',
            lang: options.lang || 'NON',
            langType: options.langType || 'DEFAULT',
        });
    }

    function setUserPreferredLangOptions(options: { side?: Side; lang?: Language; langType?: LangTypeMode}) {
        const side = options.side || 'left';
        const lang = options.lang || DEFAULT_LANGUAGE;
        const langType = options.langType || LANG_MODE_DEFAULT;
        store.dispatch('root/setUserPreferredLangOption', { side, lang, langType });
    }

    function switchMachineTrans(options: { side: Side; status: boolean }) {
        store.dispatch('root/setIsMachineTrans', options);
    }

    function setSideTransStatus(payload: { side?: Side; val: boolean }) {
        store.dispatch('setSideTransStatus', payload);
    }

    return {
        lang,
        langType,
        userPreferredLangOptions,
        switchTranslateLanguage,
        setUserPreferredLangOptions,
        switchMachineTrans,
        setSideTransStatus,
    };
}